import axios from "axios"

export default {
     async GetEnum(enumName) {
        const response = await axios.get(`/api/select/enum/${enumName}`)
        return response
    },
}